module.exports = __webpack_public_path__ + "static/media/6.f46565d4.jpg";